// extracted by css-extract-rspack-plugin
export default {"cls1":"periodControls-cls1_KSI","cls2":"periodControls-cls2_PRE periodControls-cls1_KSI"};